<script>
import { BModal, BButton } from "bootstrap-vue";
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    message: String,
    showBackButton: Boolean,
  },
  components: {
    "b-modal": BModal,
    "b-button": BButton,
  },
  data() {
    return {
      isModalVisible: this.showModal,
    };
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
      this.$emit("update:showModal", false);
    },
  },
};
</script>

<template>
  <div>
    <b-modal v-model="showModal" no-close-on-backdrop no-close-on-esc>
      <div class="text-center">
        <h4>ATENÇÃO</h4>
      </div>
      <div class="div-body-modal">
        <img src="../assets/atencao.jpg" width="120px" height="120px" alt="" />
        <p style="text-align: center;">{{ message }}</p>

        <b-button
          variant="secondary"
          @click="closeModal"
          v-show="showBackButton"
        >
          VOLTAR
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.div-body-modal {
  text-align-last: center;
}
.div-body-modal button {
  background: red;
  border: none;
  font-weight: 500;

  width: 10vw;
  border-radius: 10px;
  height: 2vw;
  color: white;
  transition: all 0.3s;
}
.div-body-modal button:hover {
  background: white;
  font-weight: 500;
  color: red;
  border: 1px solid red;
  transition: all 0.3s;
}
.modal-excluir-consulta h6 {
  text-align-last: center;
  margin-top: 3vw;
}
.btn-modal {
  margin-left: 10px;
}
</style>
